import { useTranslation } from "react-i18next";
import { useMissionControl } from "providers/navigation/MissionProvider";
import { useMissionExecution } from "providers/navigation/MissionExecutionProvider";
import { useGetMissionsQuery } from "app/services/missionStorageApiEnhanced";
import { twMerge } from "tailwind-merge";

const TERMINAL_MISSION_STATUSES = new Set(["idle", "completed", "failed", "cancelled", "canceled", "succeeded"]);

const ProgressBar = () => {
    const { t } = useTranslation("control");
    const { showMissionsInControl, setShowMissionsInControl } = useMissionControl();
    const { isExecuting, currentMissionId, executorState } = useMissionExecution();
    const { data: missionData } = useGetMissionsQuery(undefined);

    const normalizedExecutorStatus = String(executorState?.status || "").trim().toLowerCase();
    const normalizedExecutorMissionId = String(executorState?.mission_id || "").trim();
    const isExecutorMissionActive =
        Boolean(normalizedExecutorMissionId) && !TERMINAL_MISSION_STATUSES.has(normalizedExecutorStatus);
    const normalizedRunningMissionId = String(currentMissionId || "").trim();
    const activeMissionId =
        (isExecutorMissionActive && normalizedExecutorMissionId) ||
        (isExecuting && normalizedRunningMissionId) ||
        null;

    const missionNameById = new Map((missionData?.missions || []).map((mission) => [mission.id, mission.name]));
    const activeMissionName = activeMissionId
        ? (executorState?.mission_name || missionNameById.get(activeMissionId) || t("progressBar.runningMission"))
        : null;

    return (
        <button className={twMerge(
            "flex h-10 items-center justify-between space-x-2 rounded-r5 bg-black100 px-2 py-1 transition-all duration-ios-open ease-ios hover:bg-gray-900",
            showMissionsInControl && "scale-[0.98] bg-primary hover:bg-primary2"
        )} onClick={(e) => {
            e.preventDefault()
            setShowMissionsInControl(!showMissionsInControl)
        }}>
            <p className="text-h5">{t("progressBar.mission")}</p>
            <span className='text-h5 min-w-[8.5rem] truncate'>{activeMissionName || t("progressBar.noCurrentMission")}</span>
            <div className="flex  items-center justify-between space-x-3">
            </div>
        </button>
    );
};

export default ProgressBar;
